module.exports = __webpack_public_path__ + "static/media/scrum3.a5558da4.png";